export const addRowSpan = <T>(data: T[], columnKey: keyof T) => {
  const sortedData = [...data].sort((a, b) => {
    if (a[columnKey] < b[columnKey]) return -1;
    if (a[columnKey] > b[columnKey]) return 1;
    return 0;
  });
  let prevValue: any = null;
  let groupStartIndex = -1;
  const result: any[] = [];

  sortedData.forEach((item, index) => {
    const value = item[columnKey];

    if (value !== prevValue) {
      groupStartIndex = index;
      result.push({ ...item, rowSpanInternal: 1 });
    } else {
      result[groupStartIndex].rowSpanInternal += 1;
      result.push({ ...item, rowSpanInternal: 0 });
    }

    prevValue = value;
  });

  return result;
};
